import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';

export function getSystemInfoSync() {
  const res = MacleJSBridge.invokeSync(APINames.Native.GET_SYSTEM_INFO_SYNC);
  return res && JSON.parse(res);
}
